import React from 'react';
import { timestampToDateString, timestampToTimeString } from '../../utility/date_functions';

class CommentCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {
        const dateString = timestampToDateString(this.props.timestamp);
        const timeString = timestampToTimeString(this.props.timestamp);

        return (
            <div style={{border: '2px solid black', borderRadius: "10px", padding: '10px', marginBottom: '10px', marginLeft: '50px', marginRight: '50px'}}>
                <p>{this.props.body}</p>
                <p style={{fontStyle: 'italic'}}>Commented {dateString} {timeString} by {this.props.user}</p>
            </div>
        )
    }
}

export default CommentCard;
